import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import AnalysisModule from '../components/AnalysisModule';
import History from '../components/History';
import { initFirebase, saveAnalysis, subscribeToHistory } from '../firebase';

const Mackinder02 = () => {
  const [userId, setUserId] = useState(null);
  const [authStatus, setAuthStatus] = useState('Cargando autenticación...');
  const [analyses, setAnalyses] = useState([]);

  useEffect(() => {
    const init = async () => {
      const uid = await initFirebase();
      if (uid) {
        setUserId(uid);
        setAuthStatus(`✅ Conectado`);
        
        const unsubscribe = subscribeToHistory(uid, (data) => {
          setAnalyses(data);
        });
        
        return () => unsubscribe();
      } else {
        setAuthStatus('⚠️ No hay usuario autenticado');
      }
    };
    
    init();
  }, []);

  const handleSave = (query, result, type) => {
    if (userId) {
      saveAnalysis(userId, query, result, type);
    }
  };

  return (
    <div className="container">
      <Header 
        title="Mackinder - Parte 2" 
        subtitle="Aplicaciones Contemporáneas"
        authStatus={authStatus}
      />

      <section className="card" style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#004e92', marginBottom: '1rem' }}>
          La Revisión de 1919: Democratic Ideals and Reality
        </h2>
        <p style={{ lineHeight: '1.7', marginBottom: '1rem', maxWidth: '800px', margin: '0 auto' }}>
          Tras la Primera Guerra Mundial, Mackinder refinó su teoría y acuñó el término "Heartland", advirtiendo sobre el peligro de una Alemania dominante.
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <div className="grid">
          <div className="card">
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92' }}>
              🗺️ El Heartland Redefinido
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              Mackinder expandió y precisó su concepto:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li><strong>Europa del Este:</strong> La puerta de entrada al Heartland</li>
              <li><strong>Rusia:</strong> El núcleo del Heartland</li>
              <li><strong>Recursos:</strong> Petróleo, minerales, agricultura</li>
              <li><strong>Población:</strong> Reserva humana masiva</li>
            </ul>
          </div>

          <div className="card">
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92' }}>
              ⚠️ La Advertencia de Versalles
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              Mackinder advirtió a los líderes aliados en 1919:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li>No permitir que Alemania controle Europa del Este</li>
              <li>Crear estados tapón entre Alemania y Rusia</li>
              <li>Evitar una alianza germano-rusa</li>
              <li>Mantener el equilibrio de poder en Europa</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92', textAlign: 'center' }}>
          📜 La Fórmula Famosa (1919)
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', padding: '1.5rem' }}>
          <div style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)', padding: '1rem', borderRadius: '0.5rem', width: '100%', maxWidth: '600px', textAlign: 'center', borderLeft: '4px solid #ef4444' }}>
            <p style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Quien gobierne Europa del Este</p>
          </div>
          <div style={{ fontSize: '2rem', color: '#3b82f6' }}>⬇️</div>
          <div style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)', padding: '1rem', borderRadius: '0.5rem', width: '100%', maxWidth: '600px', textAlign: 'center', borderLeft: '4px solid #3b82f6' }}>
            <p style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Comandará el Heartland</p>
          </div>
          <div style={{ fontSize: '2rem', color: '#3b82f6' }}>⬇️</div>
          <div style={{ backgroundColor: 'rgba(139, 92, 246, 0.1)', padding: '1rem', borderRadius: '0.5rem', width: '100%', maxWidth: '600px', textAlign: 'center', borderLeft: '4px solid #8b5cf6' }}>
            <p style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Dominará la Isla-Mundo</p>
          </div>
          <div style={{ fontSize: '2rem', color: '#3b82f6' }}>⬇️</div>
          <div style={{ backgroundColor: 'rgba(34, 197, 94, 0.1)', padding: '1rem', borderRadius: '0.5rem', width: '100%', maxWidth: '600px', textAlign: 'center', borderLeft: '4px solid #22c55e' }}>
            <p style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Controlará el Mundo</p>
          </div>
        </div>
      </section>

      <AnalysisModule
        title="✨ Análisis Contemporáneo"
        description="Analice un conflicto o situación geopolítica actual."
        inputType="textarea"
        systemPrompt="Actúa como un analista geopolítico moderno. Analiza la situación actual proporcionada usando la Teoría del Heartland de Mackinder. Explica su relevancia en el contexto del siglo XXI. Responde en español de forma concisa."
        onSave={handleSave}
        type="section"
      />

      <History analyses={analyses} />

      <div style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', gap: '10px', zIndex: 1000 }}>
        <Link to="/mackinder01" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          ⬅️ Anterior
        </Link>
        <Link to="/" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          🏠 Inicio
        </Link>
        <Link to="/mackinder03" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          Siguiente ➡️
        </Link>
      </div>
    </div>
  );
};

export default Mackinder02;
